import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  'transform-better',
  'Transform Better: Strategies for Successful Transformation',
  `${UPLOADS}/2024/08/digitopia-transformbetter-web-02-400x400.jpg`,
  {
    download: pdf(
      '90cdb009-4914-4c39-a2a4-27975e5397a3-Strategies for Successful Transformation.pdf',
    ),
    // Designed as its own written page on 2026-08-28
    // (`content/pages/ebook-transform-better-playbook.ts`), so the card goes
    // there and `prerender.tsx` skips this slug rather than generating the
    // template over the top of it. The address is digitopia.co's own — the
    // reference screenshots came from
    // `/impact-labs/ebooks/transform-better-strategies-for-successful-transformation/`,
    // which is the long slug and not the `transform-better` derived here.
    confirmed: true,
    href:
      '/en/impact-labs/ebooks/transform-better-strategies-for-successful-transformation',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 11
